import { defineStore } from "pinia";
import { ref } from "vue";

export const useSpecificationOrderStore = defineStore('specificationOrderStore', () => {
    const applicationItemPriceField = ref('price');
    const applicationItemPriceFieldName = ref('Рассчитанная цена');
    const applicationItemShowPrice = ref(false);

    function setApplicationItemPriceField(value) {
        applicationItemPriceField.value = value;
    }

    function setApplicationItemPriceFieldName(value) {
        applicationItemPriceFieldName.value = value;
    }

    function setApplicationItemShowPrice(value) {
        applicationItemShowPrice.value = value;
    }

    return {
        applicationItemPriceField,
        setApplicationItemPriceField,
        applicationItemPriceFieldName,
        setApplicationItemPriceFieldName,
        applicationItemShowPrice,
        setApplicationItemShowPrice,
    }
});
